<template>
    <div>
        <h5 class="title is-5 has-text-primary">
            {{ $t("weekRooms.title") }} - {{ roomsCount }}
        </h5>
        <div class="w-100">
            <div class="field has-addons">
                <div class="control">
                    <button
                        class="button is-primary is-inverted"
                        @click="prevWeek"
                    >
                        <Icon family="fal" name="fa-arrow-left" />
                    </button>
                    <button class="button is-static">
                        {{ datesRange }}
                    </button>
                    <button
                        class="button is-primary is-inverted"
                        @click="nextWeek"
                    >
                        <Icon family="fal" name="fa-arrow-right" />
                    </button>
                </div>
            </div>
        </div>
        <div class="w-100">
            <div v-if="isLoading">
                <Loading />
            </div>
            <div v-else>
                <WeekRoomsChart v-if="haveData" :data="data" :labels="labels" />
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import Loading from "@/components/Loading";
import WeekRoomsChart from "./WeekRoomsChart";
import moment from "moment";

const outFormat = "DD MMM";

export default {
    name: "week-rooms",
    components: {
        Loading,
        WeekRoomsChart,
    },
    data() {
        return {
            actualStartDay: null,
            datesRange: "",
            roomsCount: 0,

            isLoading: false,
            data: [],
            labels: [],
        };
    },
    async mounted() {
        let startDate = moment(); // Now
        let endDate = moment(startDate).add(6, "days");
        this.datesRange = `${startDate.format(outFormat)} - ${endDate.format(
            outFormat
        )}`;
        this.actualStartDay = startDate;

        await this.retrieveData();
    },
    computed: {
        haveData() {
            return this.data !== [];
        },
    },
    methods: {
        async retrieveData() {
            this.isLoading = true;
            let startDate = moment(this.actualStartDay).format("YYYY-MM-DD");
            let response = await RepositoryFactory.dashboard.getWeekRooms({
                startDate: startDate,
                days: 7,
            });
            this.data = Object.values(response.data.counts);
            this.roomsCount = this.data.reduce((a, b) => a + b, 0);
            this.labels = this.getWeekLabels();
            this.isLoading = false;
        },
        getWeekLabels() {
            let startDate = this.actualStartDay;
            let labels = [];
            for (let i = 0; i < 7; i++) {
                let date = moment(startDate).add(i, "days");
                labels.push(date.format("DD/MM/YYYY"));
            }
            return labels;
        },
        prevWeek() {
            let endDate = this.actualStartDay;
            endDate.subtract(1, "day"); // Allign to previos day
            let startDate = moment(endDate).subtract(6, "days");
            this.datesRange = `${startDate.format(
                outFormat
            )} - ${endDate.format(outFormat)}`;
            this.actualStartDay = startDate;

            this.retrieveData();
        },
        nextWeek() {
            let startDate = this.actualStartDay;
            startDate.add(6, "days"); // Go to next week
            startDate.add(1, "days"); // Allign to next day
            let endDate = moment(startDate).add(6, "days");
            this.datesRange = `${startDate.format(
                outFormat
            )} - ${endDate.format(outFormat)}`;
            this.actualStartDay = startDate;

            this.retrieveData();
        },
    },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/_variables";

.button.is-primary.is-inverted:hover {
    background-color: $primary;
}
</style>